// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./src/css/ConsignmentViewer.css
// module id = 382
// module chunks = 0